export const BUILD_ID = 'cbfbbc4c-b089-486d-bb18-61adec23bcf2';
export const ENV = 'dev';
